<template lang="html">
  <v-container class="py-0">
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
        <div ref="verticalScroll" class="wrap-banner-scroll" @mousedown="onMouseDown" @mouseup="onMouseUp">
          <div class="content-banner-scroll">
            <template v-for="(item, i) in items">
              <div v-if="item.use_template" :key="'use_template' + i" :class="[`banner-scroll`, { 'disable': disabled(item) }]" :style="{ backgroundColor: item.colour }" @click="goDetail(item)">
                <div class="banner-ellipse" />
                <div class="banner-template">
                  <div class="banner-template-image">
                    <img :src="item.photo_md" :alt="item.name" @error="imageLoadError">
                  </div>
                  <div class="banner-template-content">
                    <div class="banner-template-text banner-subtext mb-2">
                      {{ item.notes }}
                    </div>
                    <div class="banner-template-text">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else :key="'use_upload' + i" :class="[`d-flex align-center banner-image-upload`, { 'disable': disabled(item) }]" @click="goDetail(item)">
                <img :src="item.photo_md" :alt="item.name" @error="imageLoadError">
              </div>
            </template>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    items: {
      required: true,
      type: Array
    },
    clickDetail: {
      required: true,
      type: Function
    }
  },
  data() {
    return {
      cursorPos: [0, 0],
      verticalScroll: null
    }
  },
  mounted() {
    window.addEventListener('mouseup', this.onMouseUp)
  },
  destroyed() {
    window.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    disabled() {
      if (!this.$isEmpty(this.$store.state.selected_outlet)) {
        const openStore = this.$store.state.selected_outlet.store_is_open === 1
        if (!openStore) {
          return true
        } else {
          if (this.$store.state.selected_type === 'DINE-IN' && this.$store.state.selected_outlet.setting.use_dinein === 1) {
            return false
          } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY' && this.$store.state.selected_outlet.setting.use_takeaway === 1) {
            return false
          } else if (this.$store.state.selected_type === 'DELIVERY' && this.$store.state.selected_outlet.setting.use_delivery === 1) {
            return false
          } else if (this.$store.state.selected_type === 'RESERVATION' && this.$store.state.selected_outlet.setting.use_reservation === 1) {
            return false
          } else {
            return true
          }
        }
      } else {
        return true
      }
    },
    async goDetail(item) {
      if (!this.disabled(item)) {
        await this.clickDetail(item)
      }
    },
    onMouseDown(ev) {
      this.cursorPos = [ev.pageX, ev.pageY]
      window.addEventListener('mousemove', this.onMouseHold)
    },
    onMouseUp(ev) {
      window.removeEventListener('mousemove', this.onMouseHold)
    },
    onMouseHold(ev) {
      ev.preventDefault()
      requestAnimationFrame(() => {
        const delta = [
          ev.pageX - this.cursorPos[0],
          ev.pageY - this.cursorPos[1]
        ]
        this.cursorPos = [ev.pageX, ev.pageY]
        if (!this.$refs.verticalScroll) return
        this.$refs.verticalScroll.scrollBy({
          left: -delta[0],
          top: -delta[1]
        })
      })
    }
  }
}
</script>
<style>
.wrap-banner-scroll {
  contain: content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow-x: scroll;
  cursor: auto;
}
.content-banner-scroll {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  position: relative;
  white-space: nowrap;
  padding: 4px;
}
.wrap-banner-scroll::-webkit-scrollbar-track,
.wrap-banner-scroll::-webkit-scrollbar,
.wrap-banner-scroll::-webkit-scrollbar-thumb {
  display: none;
}
.banner-image-upload {
  border-radius: 8px;
  overflow: hidden;
  margin-right: 12px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.content-banner-scroll > div:first-child{
  margin-left: 12px;
}
.banner-scroll {
  width: 288px;
  overflow: hidden;
  margin-right: 12px;
  -webkit-box-shadow: 0px 2px 2px 0px #0000001F;
  box-shadow: 0px 2px 2px 0px #0000001F;
  border-radius: 8px;
  z-index: 3;
  padding: 12px 8px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  cursor: pointer;
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.banner-ellipse{
  width: 194px;
  Height: 194px;
  position: absolute;
  right: -97px;
  top: -97px;
  opacity: .1;
  border-radius: 100%;
  background: #000;
  opacity: .1;
  z-index: 1;
}
.banner-template{
  position: relative;
  z-index: 2;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
  letter-spacing: normal;
  outline: none;
  position: relative;
  text-decoration: none;
}
.banner-template-image{
  width: 118px;
  height: 118px;
  -ms-flex-item-align: start;
  align-self: flex-start;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  line-height: normal;
  position: relative;
  text-align: center;
  vertical-align: middle;
  margin-right: 12px;
}
.banner-template-image > img{
  height: 118px;
  width: auto;
  max-width: 118px;
  object-fit: contain;
}
.banner-template-content{
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-item-align: center;
  align-self: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  overflow: hidden;
}
.banner-template-text{
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  white-space: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  line-height: 21.82px;
}
.banner-subtext{
  font-size: 11px;
  font-weight: 400;
  line-height: 15px;
}
.banner-image-upload > img {
  max-height: 140px;
}
.banner-scroll.disable{
  opacity: .64;
  pointer-events: none;
  cursor: not-allowed;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.banner-image-upload.disable{
  opacity: .64;
  pointer-events: none;
  cursor: not-allowed;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.banner-scroll.disable img, .banner-image-upload.disable img {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
</style>
